// import { useState, useEffect } from "react";
// import { DatePicker, TimePicker } from "antd";
// import { parsePhoneNumber } from "libphonenumber-js";
// import dayjs from "dayjs";
// import api from "../../../axios/axiosInstance";
// import {
//   clearContactsCache,
//   clearContactDetailsCache,
//   fetchContactsWithCache,
// } from "../../../data/redux/slices/ContactSlice";
// import {
//   clearContactsCache as clearLeadsCache,
//   clearContactDetailsCache as clearLeadDetailsCache,
//   fetchContactsWithCache as fetchLeadsWithCache,
// } from "../../../data/redux/slices/LeadSlice";
// import {
//   fetchCallHistory,
//   setFetchAndStoreLoading,
// } from "../../../data/redux/slices/CallHistorySlice";
// import { fetchCallHistoryAgent } from "../../../data/redux/slices/CallHistoryAgentSlice";
// import { useDispatch, useSelector } from "react-redux";
// import { clearActiveContact } from "../../../data/redux/slices/ActiveContactSlice";
// import { showToast } from "../../../data/redux/slices/ToastSlice";

// const AfterCallOffcanvas = ({ selectedLead, phoneNumber }) => {
//   const [show, setShow] = useState(false);
//   const [newContents, setNewContents] = useState([0]);
//   const [owner, setOwner] = useState(["Collab"]);
//   const [openModal2, setOpenModal2] = useState(false);
//   const dispatch = useDispatch();
// console.log(phoneNumber,"phone number in aftercalloffcanvas");

//   const activeContact = useSelector(
//     (state) => state.activeContact.activeContact
//   );

//   const [formData, setFormData] = useState({
//     phoneNumbers: {
//       countryCode: "",
//       number: "",
//     },
//     status: "",
//     note: "",
//     firstname: activeContact?.customer_name || "",
//     lastname: activeContact?.customer_name || "",
//     meeting: {
//       meetingTitle: "",
//       meetingDescription: "",
//       meetingStartDate: "",
//       meetingStartTime: "",
//       meetingType: "offline",
//       meetingLocation: "",
//     },
//   });
//   // Parse phone number when component mounts or phoneNumber prop changes
//   useEffect(() => {
//     if (phoneNumber) {
//       try {
//         const phoneNumberToParse = phoneNumber.startsWith("+")
//           ? phoneNumber
//           : "+" + phoneNumber;
//         const parsed = parsePhoneNumber(phoneNumberToParse);
//         console.log("parsed phone number object:", parsed);
//         if (parsed) {
//           setFormData((prev) => ({
//             ...prev,
//             phoneNumbers: {
//               countryCode: parsed.countryCallingCode,
//               number: parsed.nationalNumber,
//             },
//           }));
//         }
//       } catch (error) {
//         console.error("Error parsing phone number:", error);
//         // If parsing fails, try to extract country code manually
//         const match = phoneNumber.match(/^\+?(\d{1,4})(\d+)$/);
//         if (match) {
//           setFormData((prev) => ({
//             ...prev,
//             phoneNumbers: {
//               countryCode: match[1],
//               number: match[2],
//             },
//           }));
//         }
//       }
//     }
//   }, [phoneNumber]);

//   useEffect(() => {
//     if (activeContact?.customer_name) {
//       const { firstname, lastname } = splitName(activeContact.customer_name);

//       setFormData((prev) => ({
//         ...prev,
//         firstname,
//         lastname,
//       }));
//     }
//   }, [activeContact]);

//   function splitName(fullName = "") {
//     const parts = fullName.trim().split(/\s+/);
//     return {
//       firstname: parts[0] || "",
//       lastname: parts.slice(1).join(" ") || "",
//     };
//   }
//   // Common onChange handler for form inputs
//   const handleChange = (field, value) => {
//     setFormData((prev) => ({
//       ...prev,
//       [field]: value,
//     }));
//   };

//   // Handler for nested meeting fields
//   const handleMeetingChange = (field, value) => {
//     setFormData((prev) => ({
//       ...prev,
//       meeting: {
//         ...prev.meeting,
//         [field]: value,
//       },
//     }));
//   };

//   // Handler for status selection
//   const handleStatusChange = (status) => {
//     setFormData((prev) => ({
//       ...prev,
//       status: status,
//     }));
//   };

//   // Handler for date change
//   const handleDateChange = (date) => {
//     const formattedDate = date ? dayjs(date).format("YYYY-MM-DD") : "";
//     handleMeetingChange("meetingStartDate", formattedDate);
//   };

//   // Handler for time change
//   const handleTimeChange = (time) => {
//     const formattedTime = time ? dayjs(time).format("HH:mm") : "";
//     handleMeetingChange("meetingStartTime", formattedTime);
//   };

//   const handleSave = async () => {
//     try {
//       // Build payload with required fields only
//       const payload = {
//         phoneNumbers: {
//           countryCode: String(formData.phoneNumbers.countryCode || ""),
//           number: String(formData.phoneNumbers.number || ""),
//         },
//         firstname: formData.firstname,
//         lastname: formData.lastname,
//         status: formData.status || undefined,
//         note: formData.note || undefined,
//         // include meeting only when status is interested (backend expects meeting object)
//         meeting:
//           formData.status === "interested" ? formData.meeting : undefined,
//       };

//       // Remove undefined keys so the backend receives a clean body
//       Object.keys(payload).forEach((key) => {
//         if (payload[key] === undefined || payload[key] === null)
//           delete payload[key];
//       });
//       console.log("Form Data sent:", payload);

//       const response = await api.post("/call/addFormDataAfterCallEnd", payload);
//       console.log(response.data, "response from after call form");
//       dispatch(clearContactsCache());
//       dispatch(clearContactDetailsCache());
//       dispatch(clearLeadsCache());
//       dispatch(clearLeadDetailsCache());
//       dispatch(fetchContactsWithCache());
//       dispatch(fetchLeadsWithCache());
//       dispatch(clearActiveContact());
//       // Fetch and store latest call data from Yeastar
//       dispatch(setFetchAndStoreLoading(true));
//       await api.post("call/fetch-and-store");
//       // Refresh the call history lists for both admin and agent views
//       const now = new Date();
//       const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
//       const last7Start = new Date(today);
//       last7Start.setDate(today.getDate() - 7);

//       const callHistoryPayload = {
//         page: 1,
//         page_size: 10,
//         search: "",
//         status: [],
//         callType: [],
//         startDate: new Date(
//           last7Start.getFullYear(),
//           last7Start.getMonth(),
//           last7Start.getDate(),
//           0,
//           0,
//           0,
//           0
//         ).toISOString(),
//         endDate: new Date(
//           today.getFullYear(),
//           today.getMonth(),
//           today.getDate(),
//           23,
//           59,
//           59,
//           999
//         ).toISOString(),
//       };

//       // Refresh both admin and agent call history
//       dispatch(fetchCallHistory(callHistoryPayload));
//       dispatch(fetchCallHistoryAgent(callHistoryPayload));

//       setFormData({
//         phoneNumbers: {
//           countryCode: "",
//           number: "",
//         },
//         status: "",
//         note: "",
//         firstname: "",
//         lastname: "",
//         meeting: {
//           meetingTitle: "",
//           meetingDescription: "",
//           meetingStartDate: "",
//           meetingStartTime: "",
//           meetingType: "offline",
//           meetingLocation: "",
//         },
//       });

//       // open modal on success
//       dispatch(
//         showToast({
//           message:
//             response.data.type == "convertedLead"
//               ? response.data.message + ", contact converted to lead"
//               : response.data.message,
//           variant: "success",
//         })
//       );
//       setOpenModal2(true);
//     } catch (err) {
//       console.error("Failed to save after-call form:", err);
//       dispatch(
//         showToast({
//           message: "After call form failed to submit",
//           variant: "danger",
//         })
//       );
//       // Optionally set an error state or show a toast here
//     } finally {
//       dispatch(setFetchAndStoreLoading(false));
//     }
//   };

//   return (
//     <div
//       className="offcanvas offcanvas-end offcanvas-large"
//       tabIndex={-1}
//       id="afterCall_offcanvas"
//       data-bs-backdrop="static"
//     >
//       <div className="offcanvas-header border-bottom">
//         <h5 className="fw-semibold">
//           {selectedLead ? "Call Summary" : "Call Summary"}
//         </h5>
//         <button
//           type="button"
//           className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
//           data-bs-dismiss="offcanvas"
//           aria-label="Close"
//         >
//           <i className="ti ti-x" />
//         </button>
//       </div>
//       <div className="offcanvas-body">
//         <div className="row">
//           <div className="d-flex gap-3">
//             <div className="mb-3 w-50">
//               <label className="col-form-label">First name</label>
//               <input
//                 className="form-control"
//                 type="text"
//                 value={formData.firstname}
//                 onChange={(e) => handleChange("firstname", e.target.value)}
//                 required
//               />
//             </div>

//             <div className="mb-3 w-50">
//               <label className="col-form-label">Last name</label>
//               <input
//                 className="form-control"
//                 type="text"
//                 value={formData.lastname}
//                 onChange={(e) => handleChange("lastname", e.target.value)}
//                 required
//               />
//             </div>
//           </div>
//           <div className="mb-4 flex-1">
//             <h6 className="fw-semibold mb-3">Notes</h6>
//             <div className="card bg-light">
//               <textarea
//                 className="form-control"
//                 rows={3}
//                 value={formData.note}
//                 onChange={(e) => handleChange("note", e.target.value)}
//                 placeholder="Add notes about this contact..."
//               />
//             </div>
//           </div>

//           <div className="mb-4">
//             <h6 className="fw-semibold mb-2">Select Status</h6>
//             {/* <div className="d-flex gap-3">
//               {[
//                 { value: "callBack", label: "Call Back" },
//                 { label: "No Answer", value: "noAnswer" },
//                 { label: "Meeting", value: "interested" },
//                 { label: "Call Success", value: "callSuccess" },
//               ].map((item) => (
//                 <div
//                   key={item.value}
//                   onClick={() => handleStatusChange(item.value)}
//                   style={{ cursor: "pointer", display:"flex", alignItems:"center" }}
//                   className={
//                     "px-3 py-2 rounded text-center" +
//                     (formData.status === item.value
//                       ? " bg-primary text-white border border-primary"
//                       : " bg-white text-dark border border-secondary-subtle")
//                   }
//                   onMouseEnter={(e) => {
//                     if (formData.status !== item.value) {
//                       e.currentTarget.style.backgroundColor = "#f1f1f1";
//                     }
//                   }}
//                   onMouseLeave={(e) => {
//                     if (formData.status !== item.value) {
//                       e.currentTarget.style.backgroundColor = "white";
//                     }
//                   }}
//                 >
//                   {item.label}
//                 </div>
//               ))}
//             </div> */}
//             <div className="d-flex flex-column gap-2">
//   {[
//     { value: "callBack", label: "Call Back" },
//     { label: "No Answer", value: "noAnswer" },
//     { label: "Meeting", value: "interested" },
//     { label: "Call Success", value: "callSuccess" },
//   ].reduce((rows, item, index) => {
//     if (index % 2 === 0) rows.push([]);
//     rows[rows.length - 1].push(item);
//     return rows;
//   }, []).map((row, rowIndex) => (
//     <div key={rowIndex} className="d-flex gap-3">
//       {row.map((item) => (
//         <div
//           key={item.value}
//           onClick={() => handleStatusChange(item.value)}
//           style={{ cursor: "pointer", flex:1 }}
//           className={
//             "px-3 py-2 rounded text-center" +
//             (formData.status === item.value
//               ? " bg-primary text-white border border-primary"
//               : " bg-white text-dark border border-secondary-subtle")
//           }
//           onMouseEnter={(e) => {
//             if (formData.status !== item.value) {
//               e.currentTarget.style.backgroundColor = "#f1f1f1";
//             }
//           }}
//           onMouseLeave={(e) => {
//             if (formData.status !== item.value) {
//               e.currentTarget.style.backgroundColor = "white";
//             }
//           }}
//         >
//           {item.label}
//         </div>
//       ))}
//     </div>
//   ))}
// </div>

//           </div>

//           {formData.status === "interested" && (
//             <>
//               <div className="mb-3">
//                 <label className="col-form-label">
//                   Title <span className="text-danger"> *</span>
//                 </label>
//                 <input
//                   className="form-control"
//                   type="text"
//                   value={formData.meeting.meetingTitle}
//                   onChange={(e) =>
//                     handleMeetingChange("meetingTitle", e.target.value)
//                   }
//                   required
//                 />
//               </div>

//               <div className="mb-3">
//                 <label className="col-form-label">Description</label>
//                 <textarea
//                   className="form-control"
//                   rows={2}
//                   value={formData.meeting.meetingDescription}
//                   onChange={(e) =>
//                     handleMeetingChange("meetingDescription", e.target.value)
//                   }
//                   placeholder="Add meeting description..."
//                 />
//               </div>

//               <div className="row">
//                 <div className="col-md-6 mb-3">
//                   <label className="col-form-label">
//                     Start Date <span className="text-danger"> *</span>
//                   </label>
//                   <div className="icon-form-end">
//                     <span className="form-icon">
//                       <i className="ti ti-calendar-event" />
//                     </span>
//                     <DatePicker
//                       className="form-control datetimepicker deals-details"
//                       format="DD-MM-YYYY"
//                       value={
//                         formData.meeting.meetingStartDate
//                           ? dayjs(
//                               formData.meeting.meetingStartDate,
//                               "YYYY-MM-DD"
//                             )
//                           : null
//                       }
//                       onChange={handleDateChange}
//                     />
//                   </div>
//                 </div>

//                 <div className="col-md-6 mb-3">
//                   <label className="col-form-label">Start Time</label>
//                   <div className="icon-form">
//                     <span className="form-icon">
//                       <i className="ti ti-clock-hour-10" />
//                     </span>
//                     <TimePicker
//                       placeholder="Select Time"
//                       className="form-control datetimepicker-time"
//                       value={
//                         formData.meeting.meetingStartTime
//                           ? dayjs(formData.meeting.meetingStartTime, "HH:mm")
//                           : null
//                       }
//                       onChange={handleTimeChange}
//                       format="HH:mm"
//                     />
//                   </div>
//                 </div>
//               </div>
//             </>
//           )}
//         </div>

//         <div className="d-flex align-items-center justify-content-end">
//           <button
//             type="button"
//             className="btn"
//             data-bs-dismiss="offcanvas"
//             aria-label="Close"
//             // onClick={handleSave}
//           >
//             Cancel
//           </button>
//           <button
//             type="button"
//             className="btn btn-primary"
//             data-bs-dismiss="offcanvas"
//             aria-label="Close"
//             onClick={handleSave}
//           >
//             Save
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AfterCallOffcanvas;

import { useState, useEffect, useRef } from "react";
import { DatePicker, Spin } from "antd";
import Select from "react-select";
import { parsePhoneNumber } from "libphonenumber-js";
import dayjs from "dayjs";
import api from "../../../axios/axiosInstance";
import {
  clearContactsCache,
  clearContactDetailsCache,
} from "../../../data/redux/slices/ContactSlice";
import {
  clearContactsCache as clearLeadsCache,
  clearContactDetailsCache as clearLeadDetailsCache,
} from "../../../data/redux/slices/LeadSlice";
import { setFetchAndStoreLoading } from "../../../data/redux/slices/CallHistorySlice";
import { useDispatch } from "react-redux";
import { showToast } from "../../../data/redux/slices/ToastSlice";
import { meetingType } from "../../selectoption/selectoption";
import { LoadingOutlined } from "@ant-design/icons";

const AfterCallOffcanvas = ({
  selectedLead,
  phoneNumber,
  firstName,
  lastName,
  callStartedAt,
}) => {
  const [openModal2, setOpenModal2] = useState(false);
  const [selectedMeetingType, setSelectedMeetingType] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  console.log(
    selectedLead,
    phoneNumber,
    firstName,
    lastName,
    callStartedAt,
    "selectedLead, phoneNumber, firstName, lastName, callStartedAt",
  );

  const dispatch = useDispatch();
  const closeBtnRef = useRef(null);

  const [formData, setFormData] = useState({
    phoneNumbers: { countryCode: "", number: "" },
    status: "",
    note: "",
    firstname: firstName || "",
    lastname: lastName || "",
    meeting: {
      meetingTitle: "",
      meetingDescription: "",
      meetingStartDate: "",
      meetingStartTime: "",
      meetingType: "offline",
      meetingLocation: "",
    },
  });

  // Reset and re-populate form whenever call changes (phoneNumber, names, or callStartedAt)
  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      firstname: firstName || "",
      lastname: lastName || "",
      phoneNumbers: phoneNumber
        ? (() => {
            try {
              const parsed = parsePhoneNumber(
                phoneNumber.startsWith("+") ? phoneNumber : "+" + phoneNumber,
              );
              return parsed
                ? {
                    countryCode: parsed.countryCallingCode,
                    number: parsed.nationalNumber,
                  }
                : { countryCode: "", number: "" };
            } catch {
              const match = phoneNumber.match(/^\+?(\d{1,4})(\d+)$/);
              return match
                ? { countryCode: match[1], number: match[2] }
                : { countryCode: "", number: "" };
            }
          })()
        : { countryCode: "", number: "" },
    }));
  }, [firstName, lastName, phoneNumber, callStartedAt]);

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleMeetingChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      meeting: { ...prev.meeting, [field]: value },
    }));
  };

  const handleStatusChange = (status) => {
    setFormData((prev) => ({ ...prev, status }));
  };

  const handleSave = async () => {
    try {
      setIsLoading(true);

      const payload = {
        phoneNumbers: {
          countryCode: String(formData.phoneNumbers.countryCode || ""),
          number: String(formData.phoneNumbers.number || ""),
        },
        firstname: formData.firstname,
        lastname: formData.lastname,
        status: formData.status || undefined,
        note: formData.note || undefined,
        meetingProvider: "google",
        meeting:
          formData.status === "interested" ? formData.meeting : undefined,
      };

      for (const key in payload) {
        console.log(key, ":", payload[key], "payloadd");
      }

      const response = await api.post("/call/addFormDataAfterCallEnd", payload);

      closeBtnRef.current?.click();

      dispatch(clearContactsCache());
      dispatch(clearContactDetailsCache());
      dispatch(clearLeadsCache());
      dispatch(clearLeadDetailsCache());

      setFormData({
        phoneNumbers: { countryCode: "", number: "" },
        status: "",
        note: "",
        firstname: "",
        lastname: "",
        meeting: {
          meetingTitle: "",
          meetingDescription: "",
          meetingStartDate: "",
          meetingStartTime: "",
          meetingType: "offline",
          meetingLocation: "",
          meetingProvider: "",
        },
      });

      dispatch(
        showToast({
          message:
            response.data.type === "convertedLead"
              ? response.data.message + ", contact converted to lead"
              : response.data.message,
          variant: "success",
        }),
      );
      setOpenModal2(true);
    } catch (err) {
      console.error("Failed to save after-call form:", err);
      setIsLoading(false);
      dispatch(
        showToast({
          message: "After call form failed to submit",
          variant: "danger",
        }),
      );
    } finally {
      setIsLoading(false);
      dispatch(setFetchAndStoreLoading(false));
    }
  };

  return (
    <div
      className="offcanvas offcanvas-end offcanvas-large"
      tabIndex={-1}
      style={{ zIndex: 2000 }}
      id="afterCall_offcanvas"
      aria-modal="true"
      role="dialog"
    >
      {/* Hidden close button triggered programmatically after save */}
      <button
        ref={closeBtnRef}
        type="button"
        data-bs-dismiss="offcanvas"
        style={{ display: "none" }}
      />

      <div className="offcanvas-header border-bottom">
        <h5 className="fw-semibold">Call Summary</h5>
        <button
          type="button"
          className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        >
          <i className="ti ti-x" />
        </button>
      </div>

      <div className="offcanvas-body">
        <div className="row">
          {/* Name fields */}
          <div className="d-flex gap-3">
            <div className="mb-3 w-50">
              <label className="col-form-label">First name</label>
              <input
                className="form-control"
                type="text"
                value={formData.firstname}
                onChange={(e) => handleChange("firstname", e.target.value)}
                required
              />
            </div>
            <div className="mb-3 w-50">
              <label className="col-form-label">Last name</label>
              <input
                className="form-control"
                type="text"
                value={formData.lastname}
                onChange={(e) => handleChange("lastname", e.target.value)}
                required
              />
            </div>
          </div>

          {/* Notes */}
          <div className="mb-4 flex-1">
            <h6 className="fw-semibold mb-3">Notes</h6>
            <div className="card bg-light">
              <textarea
                className="form-control"
                rows={3}
                value={formData.note}
                onChange={(e) => handleChange("note", e.target.value)}
                placeholder="Add notes about this contact..."
              />
            </div>
          </div>

          {/* Status */}
          {/* <div className="mb-4">
            <h6 className="fw-semibold mb-2">Select Status</h6>
            <div className="d-flex gap-3">
              {[
                { value: "callBack", label: "Call Back" },
                { value: "noAnswer", label: "No Answer" },
                { value: "interested", label: "Meeting" },
                { value: "callSuccess", label: "Call Success" },
              ].map((item) => (
                <div
                  key={item.value}
                  onClick={() => handleStatusChange(item.value)}
                  style={{ cursor: "pointer" }}
                  className={
                    "px-3 py-2 rounded text-center" +
                    (formData.status === item.value
                      ? " bg-primary text-white border border-primary"
                      : " bg-white text-dark border border-secondary-subtle")
                  }
                  onMouseEnter={(e) => {
                    if (formData.status !== item.value)
                      e.currentTarget.style.backgroundColor = "#f1f1f1";
                  }}
                  onMouseLeave={(e) => {
                    if (formData.status !== item.value)
                      e.currentTarget.style.backgroundColor = "white";
                  }}
                >
                  {item.label}
                </div>
              ))}
            </div>
          </div> */}
          <div className="mb-4">
            <h6 className="fw-semibold mb-2">Select Status</h6>
            <div className="row g-2">
              {[
                { value: "callBack", label: "Call Back" },
                { value: "noAnswer", label: "No Answer" },
                { value: "interested", label: "Meeting" },
                { value: "callSuccess", label: "Call Success" },
              ].map((item) => (
                <div key={item.value} className="col-6">
                  <div
                    onClick={() => handleStatusChange(item.value)}
                    style={{ cursor: "pointer" }}
                    className={
                      "px-3 py-2 rounded text-center w-100" +
                      (formData.status === item.value
                        ? " bg-primary text-white border border-primary"
                        : " bg-white text-dark border border-secondary-subtle")
                    }
                    onMouseEnter={(e) => {
                      if (formData.status !== item.value) {
                        e.currentTarget.style.backgroundColor = "#f1f1f1";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (formData.status !== item.value) {
                        e.currentTarget.style.backgroundColor = "white";
                      }
                    }}
                  >
                    {item.label}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Meeting fields — shown only when status is "interested" */}
          {formData.status === "interested" && (
            <>
              <div className="mb-3">
                <label className="col-form-label">
                  Title <span className="text-danger"> *</span>
                </label>
                <input
                  className="form-control"
                  type="text"
                  value={formData?.meeting?.meetingTitle}
                  onChange={(e) =>
                    handleMeetingChange("meetingTitle", e.target.value)
                  }
                  required
                />
              </div>

              <div className="mb-3">
                <label className="col-form-label">Description</label>
                <textarea
                  className="form-control"
                  rows={2}
                  value={formData?.meeting?.meetingDescription}
                  onChange={(e) =>
                    handleMeetingChange("meetingDescription", e.target.value)
                  }
                  placeholder="Add meeting description..."
                />
              </div>

              {/* Combined Date & Time picker */}
              <div className="col-md-12 mb-3">
                <label className="col-form-label">
                  Start Date & Time <span className="text-danger"> *</span>
                </label>
                <div className="icon-form-end">
                  <span className="form-icon">
                    <i className="ti ti-calendar-event" />
                  </span>
                  <DatePicker
                    className="form-control datetimepicker deals-details"
                    format="DD-MM-YYYY hh:mm A"
                    showTime={{ use12Hours: true, format: "hh:mm A" }}
                    value={
                      formData?.meeting?.meetingStartDate
                        ? formData?.meeting?.meetingStartTime
                          ? dayjs(
                              `${formData?.meeting?.meetingStartDate} ${formData?.meeting?.meetingStartTime}`,
                              "YYYY-MM-DD hh:mm A",
                            )
                          : dayjs(
                              formData?.meeting?.meetingStartDate,
                              "YYYY-MM-DD",
                            )
                        : null
                    }
                    disabledDate={(current) =>
                      current && current < dayjs().startOf("day")
                    }
                    disabledTime={(current) => {
                      if (!current) return {};
                      const now = dayjs();
                      if (current.isSame(now, "day")) {
                        const currentHour = now.hour();
                        const currentMinute = now.minute();
                        return {
                          disabledHours: () =>
                            Array.from({ length: currentHour }, (_, i) => i),
                          disabledMinutes: (selectedHour) =>
                            selectedHour === currentHour
                              ? Array.from(
                                  { length: currentMinute },
                                  (_, i) => i,
                                )
                              : [],
                          disabledSeconds: () => [],
                        };
                      }
                      return {
                        disabledHours: () => [],
                        disabledMinutes: () => [],
                        disabledSeconds: () => [],
                      };
                    }}
                    onChange={(date) => {
                      if (!date) {
                        setFormData((prev) => ({
                          ...prev,
                          meeting: {
                            ...prev.meeting,
                            meetingStartDate: null,
                            meetingStartTime: null,
                          },
                        }));
                        return;
                      }
                      setFormData((prev) => ({
                        ...prev,
                        meeting: {
                          ...prev.meeting,
                          meetingStartDate: date.format("YYYY-MM-DD"),
                          meetingStartTime: date.format("hh:mm A"),
                        },
                      }));
                    }}
                  />
                </div>
              </div>

              {/* Meeting Type & Location/Provider */}
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="col-form-label">Meeting Type</label>
                  <Select
                    className="select2"
                    options={meetingType}
                    value={
                      formData.meeting.meetingType
                        ? meetingType.find(
                            (option) =>
                              option?.value?.toLowerCase() ===
                              formData?.meeting?.meetingType,
                          )
                        : null
                    }
                    onChange={(option) => {
                      const type = option?.value?.toLowerCase();
                      setFormData((prev) => ({
                        ...prev,
                        meeting: {
                          ...prev.meeting,
                          meetingType: type,
                          meetingProvider:
                            type === "online" ? "google" : undefined,
                          meetingLocation:
                            type === "online"
                              ? ""
                              : prev.meeting.meetingLocation,
                        },
                      }));
                      setSelectedMeetingType(option?.value);
                    }}
                    placeholder="Choose"
                    classNamePrefix="react-select"
                  />
                </div>

                {formData.meeting.meetingType === "offline" && (
                  <div className="col-md-6 mb-3">
                    <div className="mb-3">
                      <label className="col-form-label">Location</label>
                      <input
                        className="form-control"
                        type="text"
                        value={formData.meeting.meetingLocation || ""}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            meeting: {
                              ...prev.meeting,
                              meetingLocation: e.target.value,
                            },
                          }))
                        }
                      />
                    </div>
                  </div>
                )}

                {formData.meeting.meetingType === "online" && (
                  <div className="col-md-6 mb-3">
                    <div className="mb-3">
                      <label className="col-form-label">
                        Meeting Provider <span className="text-danger"> *</span>
                      </label>
                      <Select
                        className="select2"
                        options={[
                          { value: "google", label: "Google Meet" },
                          { value: "zoom", label: "Zoom" },
                        ]}
                        value={
                          formData.meeting.meetingProvider
                            ? [
                                { value: "google", label: "Google Meet" },
                                { value: "zoom", label: "Zoom" },
                              ].find(
                                (o) =>
                                  o.value === formData.meeting.meetingProvider,
                              )
                            : null
                        }
                        onChange={(option) => {
                          setFormData((prev) => ({
                            ...prev,
                            meeting: {
                              ...prev.meeting,
                              meetingProvider: option.value,
                            },
                          }));
                        }}
                        placeholder="Select Provider"
                        classNamePrefix="react-select"
                      />
                      <div className="alert alert-info d-flex align-items-center mt-2">
                        <i className="ti ti-info-circle me-2"></i>
                        <span>
                          {formData.meeting.meetingProvider === "zoom"
                            ? "A Zoom meeting link will be automatically generated when you save this meeting."
                            : formData.meeting.meetingProvider === "google"
                              ? "A Google Meet link will be automatically generated when you save this meeting."
                              : "Select a provider to create an online meeting link automatically."}
                        </span>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </>
          )}
        </div>

        {/* Footer */}
        <div className="d-flex align-items-center justify-content-end">
          <button
            type="button"
            className="btn me-2"
            onClick={() => closeBtnRef.current?.click()}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-primary"
            aria-label="Close"
            onClick={handleSave}
            disabled={isLoading}
          >
            {isLoading && (
              <Spin
                indicator={
                  <LoadingOutlined
                    spin
                    style={{ color: "white", marginRight: 5 }}
                  />
                }
                size="small"
              />
            )}
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default AfterCallOffcanvas;
